/*
// Licensed Materials - Property of HCL
// (C) Copyright HCL Technologies Limited 2001, 2021
// All Rights Reserved
*/

import { map } from 'rxjs/operators'
import BfCachedRequest from '../../../../../services/utils/BfCachedRequest'
import _ from '../../../../../services/utils/BfLodash'
import BfBasicFilter from '../../BfBasicFilter'
import { createOsDropDownItem } from '../../common/BfCheckboxTree/BfCheckboxTree'
import BfReduxStateConstants from '../../../../common/BfReduxStateConstants'

class BfSimpleOSFilter extends BfBasicFilter {
  bfCachedRequest = new BfCachedRequest()
  static NAME = 'operatingSystem'
  static PATH = `filter.${BfSimpleOSFilter.NAME}`
  static NAMESPACE = BfReduxStateConstants.DEVICES
  constructor(data = {}) {
    super(BfSimpleOSFilter.PATH, BfSimpleOSFilter.NAME, data)
  }

  getSelectedItems = () => {
    return _.size(this.operatingSystem)
  }

  getItems = () => {
    return this.bfCachedRequest.get('/api/policyGroupsUnpaginated').pipe(
      map((res) => {
        var osOptions = []
        for (var i = 0; i < res.data.length; i += 1) {
          if (osOptions.filter((e) => e.name === res.data[i].os).length === 0) {
            osOptions.push({
              name: res.data[i].os,
              id: res.data[i].os
            })
          }
        }
        return createOsDropDownItem(osOptions)
      })
    )
  }
}

export default BfSimpleOSFilter
